import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../../layouts/CommonLayout';
import EventContainer from '../../containers/EventContainer';
import { getEventList } from '../../../api/EventApi';

const EventListPage = () => {
    const [events, setEvents] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        getEventList()
        .then((data) => setEvents(data.eventListDtoList || []))
        .catch((err) => console.error(err));
    }, []);

    return (
        <CommonLayout title="이벤트">
            <div className="p-4 max-w-lg mx-auto">
                {events.length === 0 ? (
                    <div className="text-center text-gray-500 mt-20">이벤트가 없습니다.</div>
                ) : (
                    <div className="divide-y">
                        {events.map((item) => (
                            <EventContainer
                                key={item.id}
                                title={item.title}
                                createdAt={item.createdAt}
                                onClick={() => navigate(`/app/mypage/events/${item.id}`)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </CommonLayout>
    );
};

export default EventListPage;
